var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-scene"},[_c('echarts',{staticClass:"chart-stage",attrs:{"options":_vm.options},on:{"over":_vm.handleMouseOver,"out":_vm.handleMouseOut,"click":_vm.handleClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }